import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Navigation
import { useNavigate } from 'react-router-dom';

// Helpers
import Helpers from '../helpers';

// Css
import '../assets/css/app.css';

@inject('AuthStore', 'StoreStore', 'DocumentStore', 'ProductStore', 'AppStore')
@observer

class SelectStore extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        const stores = Helpers.objectToArray(this.props.StoreStore.stores).filter((store: any) => {
            if (Helpers.getUserData().isLogin) {
                if (Helpers.getUserData().stores.length >= 1) {
                    return Helpers.findIndexByCriteria(Helpers.getUserData().stores, "id", store.id) !== -1;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        });

        if (stores.length <= 1) {
            const storeId = stores[0].id;

            this.goToStore(storeId);
        }
    }

    goToStore = (id: number) => {
        localStorage.setItem('storeId', JSON.stringify(id));
        this.props.DocumentStore.resetDocuments();
        this.props.ProductStore.resetProducts();
        this.props.AppStore.socketIO.disconnect();
        Helpers.resetCategoryProducts();
        Helpers.startSocket();

        setTimeout(() => {
            this.props.navigate('/home')
        }, 500)
    }

    render() {
        const mainLogo = Helpers.getSettings().banner.data !== null ? Helpers.getMediumImageUrl(Helpers.getSettings().banner.data.attributes) : null;

        return (
            <div className="flex flex-col justify-center items-center h-screen">
                <div className="flex flex-col justify-center items-center mb-8">
                    {
                        mainLogo !== null &&
                        <img
                            src={mainLogo}
                            className="w-full md:w-60 lg:w-80 mb-2"
                        />
                    }

                    <div className="w-full lg:w-1/2 text-sm lg:text-base text-center">
                        {Helpers.getSettings().description}
                    </div>
                </div>

                <div className="flex flex-row w-full justify-center items-center">
                    {
                        Helpers.objectToArray(this.props.StoreStore.stores)
                            .filter((store: any) => {
                                if (Helpers.getUserData().isLogin) {
                                    if (Helpers.getUserData().stores.length >= 1) {
                                        return Helpers.findIndexByCriteria(Helpers.getUserData().stores, "id", store.id) !== -1;
                                    } else {
                                        return true;
                                    }
                                } else {
                                    return true;
                                }
                            })
                            .map((store: any, index: number) => {
                                const logo = store.logo.data !== null ? Helpers.getMediumImageUrl(store.logo.data.attributes) : null;

                                return (
                                    <button
                                        onClick={() => this.goToStore(store.id)}
                                        key={index}
                                        className="flex flex-col justify-center items-center mx-4"
                                    >
                                        {
                                            logo !== null &&
                                            <img
                                                src={logo}
                                                className="w-48 lg:w-64"
                                            />
                                        }

                                        <div>
                                            <div className="font-bold text-lg">{store.title}</div>
                                            <div dangerouslySetInnerHTML={{ __html: store.description }}></div>
                                        </div>
                                    </button>
                                )
                            })
                    }
                </div>
            </div>
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <SelectStore {...props} navigate={navigate} />
}

export default WithNavigate